import { useState } from "react";

import { withConfirmDefaults } from "./confirm-dialog.defaults";
import type { ConfirmDialogProps, ConfirmDialogViewModel } from "./types-confirm-dialog";

/** ViewModel do ConfirmDialog: padrões do DS sob as props da tela e a trava (sem X nem Esc) enquanto o `accept` está pendente; sem JSX. */
export function useConfirmDialog(props: ConfirmDialogProps): ConfirmDialogViewModel {
  const [pending, setPending] = useState(false);

  return {
    dialogProps: {
      ...withConfirmDefaults(props),
      ...(pending ? { closable: false, closeOnEscape: false } : null),
    },
    customFooter: props.footer,
    onPendingChange: setPending,
  };
}
